/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A model used for representing a BlobDocument. Since a blob document is a wrapper for multiple versions of the same document, this model represents a single version of the document.
 */
export interface BlobDocumentModel { 
    /**
     * ID of the BlobDocument that this model represents.
     */
    id: number;
    /**
     * Type of the BlobDocument\'s version that this model represents (usually the latest one).
     */
    documentType: string;
    /**
     * Name of the BlobDocument\'s version that this model represents (usually the latest one).
     */
    documentName: string;
}

